/* ALVENOR — animaciones y comportamiento de la tienda */
(() => {
  const raiz = document.documentElement;
  raiz.classList.add('sr-js');
  const sinMovimiento = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Intro: el emblema se dibuja una vez por sesión */
  const intro = document.querySelector('[data-sr-intro]');
  if (intro) {
    let visto = false;
    try { visto = sessionStorage.getItem('sr-intro') === '1'; sessionStorage.setItem('sr-intro', '1'); } catch (e) {}
    if (visto || sinMovimiento) intro.remove();
    else setTimeout(() => { intro.classList.add('is-fuera'); setTimeout(() => intro.remove(), 1000); }, 1700);
  }

  /* Texto que entra letra por letra */
  document.querySelectorAll('[data-sr-split]').forEach((el) => {
    let i = 0;
    const partir = (nodo) => {
      [...nodo.childNodes].forEach((n) => {
        if (n.nodeType === 3) {
          const frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach((pal) => {
            if (!pal) return;
            if (/^\s+$/.test(pal)) { frag.appendChild(document.createTextNode(' ')); return; }
            const w = document.createElement('span');
            w.className = 'sr-palabra';
            [...pal].forEach((c) => {
              const s = document.createElement('span');
              s.className = 'sr-letra';
              s.style.setProperty('--i', i++);
              s.textContent = c;
              w.appendChild(s);
            });
            frag.appendChild(w);
          });
          n.replaceWith(frag);
        } else if (n.nodeType === 1) partir(n);
      });
    };
    el.setAttribute('aria-label', el.textContent.trim());
    partir(el);
    if (!el.hasAttribute('data-sr-reveal')) el.setAttribute('data-sr-reveal', 'fade');
  });

  /* Revelado al entrar en pantalla */
  const io = new IntersectionObserver((ents) => {
    ents.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  const observar = (ctx = document) => ctx.querySelectorAll('[data-sr-reveal]:not(.is-in)').forEach((el) => io.observe(el));
  observar();
  document.addEventListener('shopify:section:load', (e) => observar(e.target));

  /* Parallax, header y escenas que dependen del scroll */
  const parallax = [...document.querySelectorAll('[data-sr-parallax]')];
  const escenas = [...document.querySelectorAll('[data-sr-ilusion]')];
  const header = document.querySelector('[data-sr-header]');
  const fija = document.querySelector('[data-sr-fija]');
  const disparadorFija = document.querySelector('[data-sr-fija-ancla]');
  let ultimoY = 0;
  let pendiente = false;
  const alScroll = () => {
    pendiente = false;
    const y = scrollY;
    const vh = innerHeight;
    if (!sinMovimiento) {
      parallax.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const f = parseFloat(el.dataset.srParallax) || 0.15;
        const centro = r.top + r.height / 2 - vh / 2;
        el.style.transform = `translate3d(0, ${(-centro * f).toFixed(1)}px, 0)`;
      });
    }
    escenas.forEach((s) => {
      const r = s.getBoundingClientRect();
      const total = r.height - vh;
      const p = Math.min(1, Math.max(0, -r.top / (total || 1)));
      s.style.setProperty('--p', p.toFixed(3));
      const n = Number(s.dataset.pasos) || 3; // 2 o 3 pasos
      const paso = Math.min(n - 1, Math.floor(p * n));
      if (s.dataset.paso !== String(paso)) s.dataset.paso = paso;
    });
    if (header) {
      header.classList.toggle('is-solido', y > 40);
      header.classList.toggle('is-oculto', y > 500 && y > ultimoY + 4 && !document.body.classList.contains('sr-menu-abierto'));
      if (y < ultimoY - 4) header.classList.remove('is-oculto');
    }
    if (fija && disparadorFija) {
      const r = disparadorFija.getBoundingClientRect();
      fija.classList.toggle('is-visible', r.bottom < 0);
    }
    ultimoY = y;
  };
  addEventListener('scroll', () => { if (!pendiente) { pendiente = true; requestAnimationFrame(alScroll); } }, { passive: true });
  addEventListener('resize', alScroll);
  alScroll();

  /* Polvo dorado del hero */
  document.querySelectorAll('[data-sr-polvo]').forEach((cv) => {
    if (sinMovimiento) return;
    const ctx = cv.getContext('2d');
    let w, h, dpr, parts = [], activo = true;
    const tam = () => {
      dpr = Math.min(devicePixelRatio || 1, 2);
      w = cv.clientWidth; h = cv.clientHeight;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      const n = Math.round(Math.min(90, (w * h) / 16000));
      parts = Array.from({ length: n }, () => ({
        x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.6 + 0.3,
        vx: (Math.random() - 0.5) * 0.15, vy: -Math.random() * 0.25 - 0.05, a: Math.random() * 0.6 + 0.2, t: Math.random() * 6.28,
      }));
    };
    tam();
    addEventListener('resize', tam);
    new IntersectionObserver(([e]) => { activo = e.isIntersecting; if (activo) requestAnimationFrame(dibujar); }).observe(cv);
    function dibujar() {
      if (!activo) return;
      ctx.clearRect(0, 0, w, h);
      for (const p of parts) {
        p.x += p.vx; p.y += p.vy; p.t += 0.02;
        if (p.y < -5) { p.y = h + 5; p.x = Math.random() * w; }
        const brillo = p.a * (0.6 + 0.4 * Math.sin(p.t));
        ctx.beginPath();
        ctx.fillStyle = `rgba(230, 200, 138, ${brillo})`;
        ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fill();
      }
      requestAnimationFrame(dibujar);
    }
    requestAnimationFrame(dibujar);
  });

  /* Galería horizontal arrastrable con flechas */
  document.querySelectorAll('[data-sr-pista]').forEach((pista) => {
    let abajo = false, x0 = 0, s0 = 0, movio = false;
    pista.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; abajo = true; movio = false; x0 = e.clientX; s0 = pista.scrollLeft; });
    addEventListener('pointermove', (e) => {
      if (!abajo) return;
      const dx = e.clientX - x0;
      if (Math.abs(dx) > 4) { movio = true; pista.classList.add('is-arrastrando'); }
      pista.scrollLeft = s0 - dx;
    });
    addEventListener('pointerup', () => { abajo = false; pista.classList.remove('is-arrastrando'); });
    pista.addEventListener('click', (e) => { if (movio) e.preventDefault(); }, true);
    const sec = pista.closest('section, .shopify-section');
    sec?.querySelectorAll('[data-sr-mover]').forEach((b) => b.addEventListener('click', () => {
      const item = pista.firstElementChild;
      const paso = item ? item.getBoundingClientRect().width + 20 : 300;
      pista.scrollBy({ left: paso * Number(b.dataset.srMover), behavior: 'smooth' });
    }));
  });

  /* Visor de fotos ampliadas (galería "cómo se ve") */
  let visor = null, lista = [], idx = 0;
  const mostrar = (i) => { idx = (i + lista.length) % lista.length; visor.querySelector('img').src = lista[idx]; };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-sr-ampliar]');
    if (!b || e.defaultPrevented) return;
    if (!visor) {
      visor = document.createElement('div');
      visor.className = 'sr-visor';
      visor.setAttribute('role', 'dialog');
      visor.setAttribute('aria-modal', 'true');
      visor.innerHTML = '<img alt=""><button type="button" class="sr-visor__cerrar" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="m5.5 5.5 13 13M18.5 5.5l-13 13"/></svg></button>'
        + '<button type="button" class="sr-flecha sr-visor__nav sr-visor__nav--prev" aria-label="Previous"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M20 12H5M10.5 6.5 5 12l5.5 5.5"/></svg></button>'
        + '<button type="button" class="sr-flecha sr-visor__nav sr-visor__nav--sig" aria-label="Next"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2"><path d="M4 12h15M13.5 6.5 19 12l-5.5 5.5"/></svg></button>';
      document.body.appendChild(visor);
      const cerrar = () => { visor.classList.remove('is-abierto'); document.body.style.overflow = ''; };
      visor.addEventListener('click', (ev) => {
        if (ev.target.closest('.sr-visor__nav--prev')) return mostrar(idx - 1);
        if (ev.target.closest('.sr-visor__nav--sig')) return mostrar(idx + 1);
        if (ev.target.tagName !== 'IMG') cerrar();
      });
      addEventListener('keydown', (ev) => {
        if (!visor.classList.contains('is-abierto')) return;
        if (ev.key === 'Escape') cerrar();
        if (ev.key === 'ArrowRight') mostrar(idx + 1);
        if (ev.key === 'ArrowLeft') mostrar(idx - 1);
      });
    }
    const grupo = b.closest('section') || document;
    lista = [...grupo.querySelectorAll('[data-sr-ampliar]')].map((x) => x.dataset.srAmpliar);
    mostrar(lista.indexOf(b.dataset.srAmpliar));
    visor.classList.add('is-abierto');
    document.body.style.overflow = 'hidden';
    visor.querySelector('.sr-visor__cerrar').focus();
  });

  /* Video: siempre sin sonido; se reproduce solo cuando está en pantalla */
  document.querySelectorAll('[data-sr-video] video').forEach((v) => {
    v.muted = true;
    v.defaultMuted = true;
    v.addEventListener('volumechange', () => { if (!v.muted) v.muted = true; });
    new IntersectionObserver(([en]) => { if (en.isIntersecting) v.play().catch(() => {}); else v.pause(); }, { threshold: 0.35 }).observe(v);
  });

  /* Menú móvil */
  const cajon = document.querySelector('[data-sr-cajon]');
  if (cajon) {
    const abrir = (si) => {
      cajon.classList.toggle('is-abierto', si);
      document.body.classList.toggle('sr-menu-abierto', si);
      document.body.style.overflow = si ? 'hidden' : '';
      if (si) cajon.querySelector('a, button')?.focus();
    };
    document.querySelectorAll('[data-sr-abrir-menu]').forEach((b) => b.addEventListener('click', () => abrir(true)));
    cajon.querySelectorAll('[data-sr-cerrar-menu]').forEach((b) => b.addEventListener('click', () => abrir(false)));
    addEventListener('keydown', (e) => { if (e.key === 'Escape' && cajon.classList.contains('is-abierto')) abrir(false); });
  }

  /* Boletín (formulario de cliente de Shopify): solo muestra el mensaje si volvió con éxito */

  /* ---------- Producto ---------- */
  document.querySelectorAll('[data-sr-producto]').forEach((raizP) => {
    const datos = JSON.parse(raizP.querySelector('[data-sr-variantes]').textContent);
    const form = raizP.querySelector('form[data-sr-form]');
    const inputId = form.querySelector('input[name="id"]');
    const btn = form.querySelector('[data-sr-agregar]');
    const btnTxt = btn.querySelector('[data-sr-agregar-txt]');
    const precio = raizP.querySelector('[data-sr-precio]');
    const antes = raizP.querySelector('[data-sr-antes]');
    const ahorro = raizP.querySelector('[data-sr-ahorro]');
    const elegido = raizP.querySelector('[data-sr-elegido]');
    const err = raizP.querySelector('[data-sr-error]');
    const pista = raizP.querySelector('[data-sr-gal-pista]');
    const minis = [...raizP.querySelectorAll('[data-sr-mini]')];
    const puntos = [...raizP.querySelectorAll('[data-sr-punto]')];
    const fija = document.querySelector('[data-sr-fija]');
    const fmt = (c) => (window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(c) : raizP.dataset.moneda.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toFixed(2)));

    const irA = (i, suave = true) => {
      const slide = pista?.children[i];
      if (!slide) return;
      pista.scrollTo({ left: slide.offsetLeft, behavior: suave ? 'smooth' : 'auto' });
      minis.forEach((m, k) => m.classList.toggle('is-activa', k === i));
      puntos.forEach((m, k) => m.classList.toggle('is-activa', k === i));
    };
    minis.forEach((m, i) => m.addEventListener('click', () => irA(i)));
    pista?.addEventListener('scroll', () => {
      const i = Math.round(pista.scrollLeft / pista.clientWidth);
      minis.forEach((m, k) => m.classList.toggle('is-activa', k === i));
      puntos.forEach((m, k) => m.classList.toggle('is-activa', k === i));
    }, { passive: true });
    // Zoom al hacer clic (escritorio)
    raizP.querySelector('[data-sr-gal]')?.addEventListener('click', (e) => {
      if (!e.target.closest('.sr-gal__slide img') || innerWidth < 990) return;
      const g = e.currentTarget;
      g.classList.toggle('is-zoom');
      if (g.classList.contains('is-zoom')) {
        const img = e.target, r = img.getBoundingClientRect();
        img.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`;
      }
    });

    const aplicar = (v) => {
      if (!v) return;
      inputId.value = v.id;
      precio.textContent = fmt(v.price);
      if (v.compare_at_price > v.price) {
        antes.textContent = fmt(v.compare_at_price); antes.hidden = false;
        ahorro.textContent = ahorro.dataset.plantilla.replace('[pct]', Math.round((1 - v.price / v.compare_at_price) * 100));
        ahorro.hidden = false;
      } else { antes.hidden = true; ahorro.hidden = true; }
      if (elegido) elegido.textContent = v.title;
      const e1 = raizP.querySelector('[data-sr-elegido-1]'), e2 = raizP.querySelector('[data-sr-elegido-2]');
      // Stock bajo: solo con inventario real de Shopify (v.stock es null si la variante no lleva inventario)
      const st = raizP.querySelector('[data-sr-stock]');
      if (st) {
        const bajo = v.stock != null && v.stock > 0 && v.stock <= Number(st.dataset.umbral);
        st.hidden = !bajo;
        if (bajo) st.querySelector('[data-sr-stock-txt]').textContent = v.stock === 1 ? st.dataset.uno : st.dataset.varios.replace('[n]', v.stock);
      }
      if (e1) e1.textContent = v.o1;
      if (e2) e2.textContent = v.o2;
      btn.disabled = !v.available;
      btnTxt.textContent = v.available ? btn.dataset.txt : btn.dataset.agotado;
      if (v.media_index != null) irA(v.media_index);
      if (fija) {
        fija.querySelector('[data-sr-fija-precio]').textContent = fmt(v.price);
        fija.querySelector('[data-sr-fija-nombre]').textContent = v.title;
        if (v.img) fija.querySelector('[data-sr-fija-img]').src = v.img;
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    };
    raizP.querySelectorAll('input[name="sr-variante"]').forEach((r) => r.addEventListener('change', () => aplicar(datos.find((v) => String(v.id) === r.value))));
    // Dos opciones (color + talla): la variante es la que coincide con ambas
    raizP.querySelectorAll('input[name="sr-op1"], input[name="sr-op2"]').forEach((r) => r.addEventListener('change', () => {
      const o1 = raizP.querySelector('input[name="sr-op1"]:checked')?.value, o2 = raizP.querySelector('input[name="sr-op2"]:checked')?.value;
      aplicar(datos.find((v) => v.o1 === o1 && v.o2 === o2));
    }));
    const inicial = datos.find((v) => String(v.id) === inputId.value);
    if (inicial && inicial.media_index != null) irA(inicial.media_index, false);

    // Cantidad
    const cant = form.querySelector('[data-sr-cant] input');
    form.querySelectorAll('[data-sr-cant] button').forEach((b) => b.addEventListener('click', () => {
      cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) + Number(b.dataset.delta));
    }));

    // Agregar al carrito con el cajón del tema
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      err.hidden = true;
      btn.disabled = true;
      btnTxt.textContent = btn.dataset.cargando;
      const cajonCarrito = document.querySelector('cart-drawer');
      const fd = new FormData(form);
      if (cajonCarrito) {
        fd.append('sections', cajonCarrito.getSectionsToRender().map((s) => s.id));
        fd.append('sections_url', urlSecciones());
      }
      try {
        const r = await fetch(`${(window.routes && routes.cart_add_url) || '/cart/add'}.js`, {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd,
        });
        const res = await r.json();
        if (res.status) throw new Error(res.description || res.message);
        if (cajonCarrito) {
          cajonCarrito.classList.remove('is-empty');
          cajonCarrito.renderContents(await conSecciones(res, cajonCarrito));
        } else location.href = (window.routes && routes.cart_url) || '/cart';
      } catch (ex) {
        err.textContent = ex.message || 'Error';
        err.hidden = false;
      } finally {
        btn.disabled = false;
        btnTxt.textContent = btn.dataset.txt;
      }
    });
    document.querySelector('[data-sr-fija-btn]')?.addEventListener('click', () => form.requestSubmit());
  });

  /* 30/10/2026: Shopify devuelve sections = null si sections_url es una página que redirige (p. ej. /products/… cuando
     el mercado usa /en-en/): el producto entraba al carrito pero salía "Cannot read properties of null (reading
     'cart-drawer')". Se pide el cajón al carrito del idioma actual y, si aun así no viene, se pide aparte. */
  function urlSecciones() { return (window.routes && routes.cart_url) || '/cart'; }
  async function conSecciones(res, cajon) {
    if (res.sections && Object.values(res.sections).every(Boolean)) return res;
    const ids = cajon.getSectionsToRender().map((s) => s.id).join(',');
    res.sections = await (await fetch(`${urlSecciones()}?sections=${ids}`)).json();
    return res;
  }

  /* Burbuja del carrito en el header propio: se actualiza cuando el tema publica cambios */
  const burbuja = document.querySelector('[data-sr-burbuja]');
  if (burbuja && window.subscribe && window.PUB_SUB_EVENTS) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
      const n = ev?.cartData?.item_count;
      if (n != null) { burbuja.textContent = n; burbuja.hidden = n === 0; }
    });
  }
  const refrescarBurbuja = async () => {
    if (!burbuja) return;
    try { const c = await (await fetch('/cart.js')).json(); burbuja.textContent = c.item_count; burbuja.hidden = c.item_count === 0; } catch (e) {}
  };
  document.addEventListener('cart:refresh', refrescarBurbuja);
  const obsCarrito = document.querySelector('cart-drawer');
  if (obsCarrito) new MutationObserver(refrescarBurbuja).observe(obsCarrito, { attributes: true, attributeFilter: ['class'] });

  /* Oferta de Halloween (22/10/2026): cuenta regresiva REAL hasta data-fin (31/10 23:59 Nueva York). Al llegar a cero
     la oferta se oculta; el carrito vuelto a dibujar después ya la muestra sin Halloween. */
  const pintarCuentas = () => {
    document.querySelectorAll('[data-sr-cuenta]').forEach((el) => {
      const ms = new Date(el.dataset.fin) - Date.now();
      if (ms <= 0) { (el.closest('[data-sr-anuncio-fija]') || el.closest('.sr-anuncio__item'))?.remove(); el.closest('[data-sr-oferta-halloween]')?.querySelector('.sr-upsell__cuenta')?.remove(); return; }
      const s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sg = s % 60;
      el.textContent = `${d ? d + 'd ' : ''}${String(h).padStart(2, '0')}h ${String(m).padStart(2, '0')}m ${String(sg).padStart(2, '0')}s`;
    });
  };
  pintarCuentas();
  setInterval(pintarCuentas, 1000);

  /* Upsell del carrito: "+ Silver / + Gold" agrega el anillo o el brazalete y vuelve a dibujar el cajón */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-sr-upsell-add]');
    if (!b) return;
    b.disabled = true;
    const cajon = document.querySelector('cart-drawer');
    const fd = new FormData();
    // la variante sale de los desplegables (color + talla en el anillo; con una sola opción el valor ya es el id)
    const botones = b.closest('.sr-upsell__botones');
    const o1 = botones?.querySelector('[data-sr-upsell-o1]')?.value;
    const talla = botones?.querySelector('[data-sr-upsell-talla]')?.value;
    const mapa = botones?.dataset.srUpsellMapa;
    fd.append('id', (mapa ? JSON.parse(mapa)[`${o1}|${talla}`] : o1) || b.dataset.srUpsellAdd);
    fd.append('quantity', '1');
    if (cajon) { fd.append('sections', cajon.getSectionsToRender().map((s) => s.id)); fd.append('sections_url', urlSecciones()); }
    try {
      const r = await fetch(`${(window.routes && routes.cart_add_url) || '/cart/add'}.js`, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd });
      const res = await r.json();
      if (res.status) throw new Error(res.description || res.message);
      if (cajon) cajon.renderContents(await conSecciones(res, cajon)); else location.reload();
    } catch (ex) { b.disabled = false; }
  });
})();
